import React from "react"
import { db } from '../firebase'
import { useState, useEffect } from 'react'
import '../css/Highscore.css'
import ConnectionToast from "../components/ConnectionToast"
import '../css/Base.css'
import tableSort from "table-sort-js/table-sort";

function Highscore() {

    const [isLoading, setIsLoading] = useState(true);
    const [loadedData, setLoadedData] = useState([]);

    useEffect(() => {
        setIsLoading(true);

        db.collection("Players").get().then((querySnapshot => {
            querySnapshot.forEach((userids => {
                if (userids.data().betsWon !== undefined && userids.data().betsLost !== undefined) {

                    var arrayData = []
                    var query = db.collection("Players")
                    query = query.where("totalBets", ">", 0)

                    var counter = 0;
                    var counterRanking = 1;
                    var processedScores = 0;


                    query.get().then((querySnapshot) => {
                        counter = querySnapshot.size;

                        querySnapshot.forEach((doc) => {
                            arrayData.push(doc.data())
                            processedScores++
                        });

                        arrayData.forEach((collection => {
                            collection.ranking = counterRanking;
                            counterRanking++
                        }))

                        if (processedScores === counter) {
                            setLoadedData(arrayData)
                            setIsLoading(false)
                            tableSort()
                        }
                    })
                }
            }))
        }))

        // OFFLINE ONLINE TOAST
        let connectionLostToast = document.getElementById('connectionLost')
        connectionLostToast.setAttribute('autohide', false)

        window.addEventListener('offline', function () {
            connectionLostToast.style.display = "block"
        });

        window.addEventListener('online', function () {
            connectionLostToast.style.display = "none"
        });

    }, []);

    //if we are loading the data return loading .. 
    if (isLoading && loadedData.length === 0) {
        return (
            <>
                <div className="lds-circle" />
                <p className="text-light text-center"> THERE ARE NO HIGHSCORES AVAILABLE</p>
                <ConnectionToast />
            </>
        )
    }

    //if we are loading the data return loading .. 
    if (isLoading) {
        return (
            <>
                <div className="lds-circle" />
                <ConnectionToast />
            </>
        )
    }


    return (
        <div className="Highscore pt-5">
            <ConnectionToast />
            <div className="card me-4 bg-dark text-center col-md-8 offset-md-3" id="card-highscore" >
                <h2 className="card-header text-white font-link-header2">HIGHSCORE</h2>
                <table id="sortable" className="table-sort remember-sort table table-dark mt-2">

                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Username</th>
                            <th scope="col">Bet won</th>
                            <th scope="col">Bet lost</th>
                            <th className="order-by-desc" scope="col">Win percentage</th>
                            <th scope="col">Total points</th>
                        </tr>
                    </thead>
                    <tbody>

                        {loadedData.map((data) => {

                            return (

                                <tr key={data.ranking} >
                                    <th scope="row">{data.ranking}</th>
                                    <td>{data.username}</td>
                                    <td>{data.betsWon}</td>
                                    <td>{data.betsLost}</td>
                                    <td>{Math.round((data.betsWon / (data.betsWon + data.betsLost) * 100))} %</td>
                                    <td>{data.betsWon * 10 - data.betsLost * 5}</td>
                                </tr>

                            )
                        })}

                    </tbody>
                </table>
            </div>
        </div>

    );
}

export default Highscore